<template>
  <v-container class="permissions-presets">
    <v-subheader>{{ lang.permissions.new.presets.title }}</v-subheader>
    <v-list>
      <v-list-item
        v-for="(preset, index) in presets"
        v-model="isPresetActive[index]"
        :key="index"
        @click.stop="selectPreset({ ...preset.permissions })"
      >
        <v-list-item-content>{{ preset.title }}</v-list-item-content>
      </v-list-item>
    </v-list>
  </v-container>
</template>

<script>
import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'

export default {
  mixins: [ appdata ],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    permissions: {
      get: function () {
        return this.value || {}
      },
      set: function (val) {
        this.$emit('input', { ...val })
      }
    },
    presets () {
      return defaults.permissions.presets(this.lang.permissions) || []
    },
    isPresetActive () {
      return this.presets.map(
        preset =>
          JSON.stringify(preset.permissions) === JSON.stringify(this.permissions)
      )
    }
  },
  methods: {
    selectPreset (preset) {
      this.permissions = { ...Object.assign({}, preset) }
    }
  }
}
</script>
